import React from 'react';
import { withStyles } from '@material-ui/core'
import styles from './styles'
import APIService from "../../../apis/amplify/APIService";
import SectionTitleContainer, { SectionTitle } from "../../../components/SectionTitleContainer";
import Loading, { LoadingText, Progress } from '../../../components/Loading';
import If from "../../../components/If";

class TermsContent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: null,
        }
    }

    componentDidMount() {
        APIService.getAppConfig()
            .then(response => {
                this.setState({ data: response })
            })
    }

    render() {
        return (
            <div style={{ marginBottom: '50px' }}>

                <SectionTitleContainer>
                    <SectionTitle>Terms &amp; Conditions</SectionTitle>
                </SectionTitleContainer>

                <div>
                    <If as={Loading} condition={this.state.data === null} style={{ paddingTop: 30 }}>
                        <Progress/><LoadingText>Loading terms &amp; conditions</LoadingText>
                    </If>
                    <If as={"div"} condition={this.state.data !== null} style={{ paddingTop: 30 }}>
                        <p style={{ whiteSpace: 'pre-wrap' }}>
                            {(this.state.data !== null) && this.state.data.mobile_terms_and_conditions}
                        </p>
                    </If>
                </div>

            </div>
        )
    }
}

export default withStyles(styles)(TermsContent)
